import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { resetUserPassword, userQueryKeys } from '../api/users.api';
import type { ResetPasswordPayload } from '../types/user.types';

export function useResetPassword(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: ResetPasswordPayload }) =>
      resetUserPassword(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: userQueryKeys.all() });
      toast.success('Password reset successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to reset password');
    },
  });
}
